enum GravityFormsPopupModalEnum {
  VDP = "VDP",
  VLP = "VLP",
  All = "All",
}

export default GravityFormsPopupModalEnum;
